import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {encodingClothsImages} from '../cloths-mockup';
import {encodingSymbolsImages} from '../symbols-mockup';
import {GeneralDragAndDropComponent} from '../../General/g-drag-and-drop';

@Component({
  selector: 'app-read-message-content',
  templateUrl: './read-message-content.component.html',
  styleUrls: ['./read-message-content.component.css']
})
export class ReadMessageContentComponent extends GeneralDragAndDropComponent implements OnChanges {

  @Input() counter: number;
  @Input() level: number;
  @Input() inputEncodings: number[][];
  @Input() inputEncodedMessage: number[];
  @Output() isSolvedChange = new EventEmitter<boolean>();

  // all the encodings for the different cloths
  encodings: number[][] = [];
  // an encoded message that the user has to encode into a cloth element.
  encodedMessage: number[] = [];
  solution: number[] = [];
  clothsImages = encodingClothsImages;
  symbolImages = encodingSymbolsImages;
  solved = false;

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    this.initValues();
  }

  initValues() {
    super.initValues();
    this.encodings = [];
    this.solution = [];
    this.encodedMessage = [];
    this.solved = false;
  }

  checkSolution() {
    if (this.compareArrays(this.solution, this.dropValues)) {
      this.solved = true;
      this.isSolvedChange.emit(this.solved);
    } else {
      this.solved = false;
      this.isSolvedChange.emit(this.solved);
    }
  }

  generateNextExercise() {
    this.counter ++;
    this.initValues();
  }

  setEncoding(encoding: number[][]) {
    this.encodings = encoding;
    this.createEncodedMessage();
    this.setAllDragElementIds();
  }

  createEncodedMessage() {
    if (this.inputEncodedMessage === undefined) {
      const length = this.getEncodedMessageLength();
      const idx = [];
      for (let i = 0; i < length; i++) {
        const randId = Math.floor((Math.random() * this.encodings.length));
        for (let j = 0; j < this.encodings[randId].length; j++) {
          idx.push(this.encodings[randId][j]);
        }
        this.solution.push(randId);
        this.dropValues.push(-1);
      }
      this.encodedMessage = idx;
    } else {
      for (let i = 0; i < this.inputEncodedMessage.length / this.encodings[0].length; i++) {
        this.dropValues.push(-1);

        for (let j = 0; j < this.encodings.length; j++) {
          let founded = true;
          for (let n = 0; n < this.encodings[j].length; n++) {
            if (this.inputEncodedMessage[(i * this.encodings[j].length) + n] !== this.encodings[j][n]) {
              founded = false;
              break;
            }
          }
          if (founded) {
            this.solution.push(j);
            break;
          }
        }
      }

      this.encodedMessage = this.inputEncodedMessage;
    }
  }

  setAllDragElementIds() {
    this.allDragElementIds = [];
    for (let i = 0; i < this.encodings.length; i++) {
      this.allDragElementIds.push('cloth_' + i.toString());
    }
  }

  getHidden(id: number) {
    if (this.currentDragElementId === null) {
      return true;
    }

    return !(this.currentDragElementId.value === 'cloth_' + id.toString());
  }

  getActive(i: number) {
    return this.currentBelowElement !== null && parseInt(this.currentBelowElement.id, 10) === i;
  }

  getClothImgSrc(idx) {
    if (idx === -1) {
      return './assets/images/clothColors/empty.png';
    }
    return this.clothsImages[idx];
  }

  getSymbolImgSrc(idx) {
    return this.symbolImages[idx];
  }

  getEncodedMessageLength() {
    if (this.level === 1) {
      return 1;
    } else if (this.level === 2) {
      return 2;
    } else {
      return 3;
    }
  }

  getNumberOfEncodings() {
    if (this.level === 1) {
      return 3;
    } else if (this.level === 2) {
      return 4;
    } else {
      return 5;
    }
  }

  getSymbolsMaxSize() {
    const width = Math.min((100 / this.encodedMessage.length), 10);
    return width;
  }

  getDragElementMaxSize() {
    return 9; // the width of the cloths symbols, that is also used in the html file: 10%
  }

  getMarginLeft() {
    const messageTotalSize = this.encodedMessage.length * this.getSymbolsMaxSize();
    const clothSymbolstotalSize = this.encodings.length * (this.getDragElementMaxSize() + 4); // 2 is the margin of the cloths images

    const maxWidth = Math.max(messageTotalSize, clothSymbolstotalSize);

    return (100 - maxWidth) / 2;
  }

  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }
}
